// @TODO: https://reactnavigation.org/docs/drawer-layout/ works on native and web
/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ABOUT_ROUTE,
  DISCOVER_ROUTE,
  FEEDBACK_CHAT_ROUTE,
  FRIENDS_ROUTE,
  FUNDRAISING_ROUTE,
  GOALS_ROUTE,
  GOAL_ROUTE,
  GROUPS_ROUTE,
  HELP_ROUTE,
  LINK_ACCOUNT_ROUTE,
  NEW_GOAL_ROUTE,
  PROFILE_ROUTE,
  READ_ROUTE,
  SETTINGS_ROUTE,
  WHATS_NEW_ROUTE,
  WRINKLES_ROUTE,
  YEAR_IN_REVIEW_ROUTE,
  addWrinkly101,
  // @TODO: fetchVerses,
  setActiveGoalId,
} from '@utils/store/actions';
import {
  Image,
  Linking,
  Platform,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from 'react-native';
import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
/* @TODO:
import {
  useOnMessage,
  useOnNotificationPress,
} from '@utils/utilities/pushNotifications';
*/
import BibleInAYearDialog from './BibleInAYearDialog';
import CPassage from '@classes/Passage';
import FullScreenScrollView from '@components/common/FullScreenScrollView';
import Header from '@components/Header';
import Icon from '@react-native-vector-icons/material-design-icons';
import MainDashboard from '@components/MainDashboard';
import ProgressIndicator from '@components/ProgressIndicator';
import RateDialog from '@components/RateDialog';
import SideDrawer from './SideDrawer';
import SideDrawerWrapper from './SideDrawerWrapper';
import SuperSearch from './SuperSearch';
import Text from '@components/common/Text';
import TranslationSelectionDialog from '@components/TranslationSelectionDialog';
// @TODO: import VerseText from '@utils/db/models/VerseText';
import {
  add as dateFnsAdd,
} from 'date-fns';
// @TODO: import db from '@utils/db';
import fb from '@utils/firebase';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';
import utilities from '@utils/utilities';

const ELEPHANT_STANDARD = require('@assets/img/characters/elephant-standard-shadow.png');
const BRAIN_STANDARD = require('@assets/img/characters/brain-standard-shadow.png');
const ELEPHANT_BIBLE_IN_A_YEAR = require('@assets/img/characters/elephant-standard.png'); // @TODO: update
const BRAIN_YEAR_IN_REVIEW = require('@assets/img/characters/brain-standard-full-crop.png'); // @TODO: update

const Home = () => {
  const dispatch = hooks.useTypedDispatch();
  const navigation = hooks.useNavigation();
  const locationState = hooks.useLocationState();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  /* @TODO:
  const [_allVerseTexts, setAllVerseTexts] = useState([]);

  const translations = hooks.useTypedSelector((state: any) => state.translations);

  useEffect(() => { // @TODO: yeet
    const fetchAllVerseTextsByTranslationId = async () => {
      // @TODO: await db.adapter.unsafeResetDatabase()
      const foo = await VerseText.numVersesDownloadedByTranslationIds(db, translations.map((t) => t.id));
      setAllVerseTexts(foo);
    };

    fetchAllVerseTextsByTranslationId();
  }, [translations]);
  */

  const __notificationPermStatus = hooks.useRequestNotificationPermission('Wrinkly sends notifications for the passage of the day and reminders for your goals. You can manage your notification preferences in the Settings page.'); // @TODO: i18n

  const [_searchOpen, setSearchOpen] = useState(!!locationState.q);
  const [_rateDialogOpen, setRateDialogOpen] = useState(false);
  const [_completedExpanded, setCompletedExpanded] = useState(false);

  const addWrinkly101InFlight = hooks.useTypedSelector((state: any) => state.loadingStates?.addWrinkly101);
  const fetchGoalsCompleted = hooks.useTypedSelector((state: any) => !state.loadingStates?.fetchGoals);

  const isYearlyGoalAlreadyAdded = hooks.useTypedSelector((state: any) => !!state.goals[globals.yearPlanGoalId]);

  const numRetryLater = hooks.useTypedSelector((state: any) => Object.keys(state.completedLessons).length);
  const betaOn = hooks.useTypedSelector((state) => state.userSettings.beta_on);

  const {width} = useWindowDimensions();

  // @TODO: useOnMessage();
  // @TODO: useOnNotificationPress();

  const notificationPreferences = hooks.useTypedSelector((state) => state.notificationPreferences);

  const activeGoalId = hooks.useTypedSelector((state) => { // @TODO: should this be a prop instead?
    let agi = state.settingsActiveGoalId;
    if (!agi || !Object.keys(state.goals).map((gid) => +gid).includes(agi)) {
      agi = (Object.values(state.goals)[0] as any)?.id;
    }
    if (agi && agi !== state.settingsActiveGoalId) {
      dispatch(setActiveGoalId(agi));
    }

    return agi;
  });

  const [_sideDrawerOpen, setSideDrawerOpen] = useState(false);
  const [_isBibleInAYearDialogOpen, setIsBibleInAYearDialogOpen] = useState(false);

  hooks.useBackButton(() => {
    if (_sideDrawerOpen) {
      setSideDrawerOpen(false);
      return true;
    }
    return false;
  });

  const user = hooks.useTypedSelector((state) => state.oakUser);
  const goals = hooks.useTypedSelector((state) => state.goals);
  const goalProgress = hooks.useTypedSelector((state) => state.goalProgress);
  const unreadChatMessages = hooks.useTypedSelector((state) => {
    return state.chatMessages.filter((cm) => !cm.is_read);
  }, (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));
  const whatsNewLastReadVersion = hooks.useTypedSelector((state) => state.whatsNewLastReadVersion);
  const lifetimePeanuts = hooks.useTypedSelector((state) => state.oakUser.lifetime_peanuts);

  const hasNewFollowers = false; // @TODO: hooks.useTypedSelector((state) => { // @TODO: f.created at is the follower's created_at timestamp, not the time they became friends...can add this in the future
  // @TODO:   return state.oakUserFollowers.some((f) => new Date(f.created_at).getTime() > state.lastViewedFollowersTimestamp);
  // @TODO:  });

  const thisVersionHasWhatsNewNotes = hooks.useTypedSelector((state) => !!state.whatsNewNotes.filter((n) => {
    return globals.appVersionNumber === n.app_version;
  }).length);

  const isWhatsNewBadgeVisible = (
    notificationPreferences.whats_new_channels?.push &&
    thisVersionHasWhatsNewNotes &&
    globals.appVersionNumber !== whatsNewLastReadVersion
  );

  const sideDrawerItem = (
    <Header.Icon
      icon='menu'
      hasBadge={!!((unreadChatMessages.length > 0) || hasNewFollowers)}// @NOTE: isWhatsNewBadgeVisible intentionally left out...badge on that item is good enough and shouldn't need to be here
      onPress={() => {
        setSideDrawerOpen((curr) => !curr);
        setSearchOpen(false);
      }}
    />
  );
  const searchItem = (
    <Header.Icon
      icon='magnify'
      onPress={() => {
        navigation.setParams({q: null});
        setSearchOpen((curr) => !curr);
      }}
    />
  );

  const [activeMemoryGoals, activeReadingGoals, activeGroupGoals, completedGoals] = useMemo(() => {
    const _activeMemoryGoals = [];
    const _activeReadingGoals = [];
    const _activeGroupGoals = [];
    const _completedGoals = [];
    Object.values(goals || []).filter((goal: any) => ['active', 'archived', 'complete'].includes(goal.user_goal?.status)).forEach((goal: any) => {
      const dateLastGoalActivity = Math.max(...Object.values(goalProgress[goal.id]?.[user.id] || {}).map((gp: any) => new Date(gp.dla || 0).getTime())) || new Date(goal.user_goal.created_at).getTime();
      const textStyles = [];
      const iconStyles = [styles.goalIcon];
      let iconName = '';
      let wrinkleReady = false;
      const progress = utilities.getGoalProgress(goal.id);
      const isGoalComplete = progress.numCompletedModules === goal.modules.length;
      if (isGoalComplete || goal.user_goal.status === 'complete') {
        textStyles.push(styles.completedGoalText);
        iconStyles.push(styles.completedGoalIcon);
        iconName = 'check';
      } else if (goal.user_goal.status === 'archived') {
        textStyles.push(styles.completedGoalText);
        iconStyles.push(styles.completedGoalIcon);
        iconName = 'archive';
      }
      if (goal.id === activeGoalId) {
        textStyles.push(styles.activeGoalText);
        iconStyles.push(styles.activeGoalIcon);
      }

      if (goal.goal_type === 'memory' && goal.modules.some((module) => {
        return module.assignments.some((assignment) => {
          if (!assignment.assignment_object.passage) {
            // @TODO: this shouldn't happen in memory goals, but there's nothing preventing it right now
            return false;
          }
          return CPassage.createFromObject(assignment.assignment_object.passage).getWrinkles().some((w) => {
            return w.level_number > 0 && w.level_number < globals.srsLevelWrinkleIsEarnedAt && w.date_last_passed && (new Date() >= dateFnsAdd(new Date(w.date_last_passed), {days: 1}));
          });
        });
      })) {
        // this goal has at least one test that's open
        wrinkleReady = true;
      }

      const goalEntry = {
        key: `goal_${goal.id}`,
        title: goal.title,
        // @TODO: badge if haven't worked on this in a while
        // @TODO: badge if completion deadline approaching
        iconName,
        mostRecentActivity: dateLastGoalActivity,
        iconComponent: iconName ? null : (
          <View style={iconStyles}>
            <ProgressIndicator
              completedNum={progress.numCompletedAssignments}
              inProgressNum={progress.numInProgressAssignments}
              totalNum={progress.numAssignments}
              size={18}
              width={4}
              prefill={100}
              hasBadge={!!wrinkleReady}
            />
          </View>
        ),
        textStyles,
        iconStyles,
        onPress: () => {
          dispatch(setActiveGoalId(goal.id));
          setSideDrawerOpen(false);
          navigation.navigate(GOAL_ROUTE);
        },
      };
      if (isGoalComplete || goal.user_goal.status === 'complete' || goal.user_goal.status === 'archived') {
        _completedGoals.push(goalEntry);
      } else {
        if (goal.goal_type === 'memory') { // @TODO: enum
          _activeMemoryGoals.push(goalEntry);
        } else if (goal.goal_type === 'reading') { // @TODO: enum
          _activeReadingGoals.push(goalEntry);
        } else if (goal.goal_type === 'group') { // @TODO: enum
          _activeGroupGoals.push(goalEntry);
        }
      }
    });

    return [_activeMemoryGoals, _activeReadingGoals, _activeGroupGoals, _completedGoals];
  }, [activeGoalId, dispatch, goals, styles.activeGoalIcon, styles.activeGoalText, styles.completedGoalIcon, styles.completedGoalText, styles.goalIcon, goalProgress, user.id, navigation]);

  const sideDrawerOptions = useMemo(() => [
    {
      key: 'goals',
      isSectionTitle: true,
      title: i18n('goals'),
    },
    {
      key: 'myMemoryGoals',
      title: i18n('myMemoryGoals'),
      iconName: 'trophy',
      onPress: () => navigation.navigate(GOALS_ROUTE, {goalType: 'memory'}), // @TODO: scroll to appropriate section
    },
    ...activeMemoryGoals,
    ...(activeReadingGoals.length ? [{
      key: 'myReadingPlans',
      title: i18n('myReadingPlans'),
      iconName: 'book-open-outline',
      onPress: () => navigation.navigate(GOALS_ROUTE, {goalType: 'reading'}), // @TODO: scroll to appropriate section
    }] : []),
    ...activeReadingGoals,
    ...(activeGroupGoals.length ? [{
      key: 'myGroupGoals',
      title: i18n('myGroupGoals'),
      iconName: 'account-group',
      onPress: () => navigation.navigate(GOALS_ROUTE, {goalType: 'group'}), // @TODO: scroll to appropriate section
    }] : []),
    ...activeGroupGoals,
    ...(completedGoals.length ? [{
      key: 'completedGoals',
      title: (
        <React.Fragment>
          {i18n('completedGoals')}
          <Icon style={styles.expandIcon} name={_completedExpanded ? 'chevron-up' : 'chevron-down'} color={styles.colors.lightGray} />
        </React.Fragment>
      ),
      iconName: 'star',
      onPress: () => setCompletedExpanded((curr) => !curr),
    }] : []),
    ...((completedGoals.length && _completedExpanded) ? completedGoals : []),
    {
      key: 'newGoal',
      title: i18n('createNewGoal'),
      iconName: 'plus',
      onPress: () => navigation.navigate(NEW_GOAL_ROUTE),
    },
    {
      key: 'discoverGoals',
      title: i18n('discoverGoals'),
      iconName: 'magnify',
      onPress: () => navigation.navigate(DISCOVER_ROUTE),
    },
    {
      key: 'explore',
      horizontalRuleBefore: true,
      isSectionTitle: true,
      title: i18n('explore'),
    },
    {
      key: 'read',
      title: i18n('read'),
      iconName: 'book-open-page-variant',
      onPress: () => navigation.navigate(READ_ROUTE),
    },
    {
      key: 'wrinkles',
      title: i18n('wrinkles'),
      iconName: 'trophy-award',
      onPress: () => navigation.navigate(WRINKLES_ROUTE),
    },
    /* @TODO:
    {
      key: 'BibleKnowledge',
      title: i18n('BibleKnowledge'),
      iconName: 'head-question',
      onPress: () => navigation.navigate(BIBLE_KNOWLEDGE_ROUTE),
    },
    */
    {
      key: 'community',
      horizontalRuleBefore: true,
      isSectionTitle: true,
      title: i18n('community'),
    },
    {
      key: 'friends',
      title: i18n('friends'),
      iconName: 'earth',
      hasBadge: !!hasNewFollowers,
      onPress: () => navigation.navigate(FRIENDS_ROUTE),
    },
    {
      key: 'groups',
      title: i18n('groups'),
      iconName: 'account-multiple',
      onPress: () => navigation.navigate(GROUPS_ROUTE),
    },
    {
      key: 'fundraising',
      title: i18n('fundraising'),
      iconName: 'hand-coin',
      onPress: () => navigation.navigate(FUNDRAISING_ROUTE),
    },
    {
      key: 'account',
      horizontalRuleBefore: true,
      isSectionTitle: true,
      title: i18n('account'),
    },
    ...(Platform.OS === 'web'
      ? []
      : [{
        key: 'linkAccount',
        title: i18n('linkAccount'),
        iconName: 'link-variant',
        hasBadge: true,
        hidden: user.auth_provider_info !== 'anonymous',
        onPress: () => navigation.navigate(LINK_ACCOUNT_ROUTE),
      }]
    ),
    {
      key: 'profile',
      title: i18n('profile'),
      iconName: 'account',
      onPress: () => navigation.navigate(PROFILE_ROUTE),
    },
    {
      key: 'settings',
      title: i18n('settings'),
      iconName: 'cog',
      onPress: () => {
        navigation.navigate(SETTINGS_ROUTE);
      },
    },
    {
      key: 'other',
      horizontalRuleBefore: true,
      isSectionTitle: true,
      title: i18n('other'),
    },
    {
      key: 'whatsNew',
      title: i18n('whatsNew'),
      iconName: 'gift',
      hasBadge: !!isWhatsNewBadgeVisible,
      onPress: () => navigation.navigate(WHATS_NEW_ROUTE),
    },
    {
      key: 'help',
      title: i18n('help'),
      iconName: 'help-circle',
      onPress: () => navigation.navigate(HELP_ROUTE),
    },
    {
      key: 'feedbackChat',
      title: i18n('feedbackChat'),
      iconName: 'forum',
      hasBadge: unreadChatMessages.length > 0,
      onPress: () => navigation.navigate(FEEDBACK_CHAT_ROUTE),
    },
    {
      key: 'rateWrinkly',
      title: i18n('rateWrinkly'),
      iconName: 'star',
      onPress: () => {
        fb.logEvent(fb.analytics, 'rate_wrinkly', {location: 'side_drawer'});
        if (Platform.OS === 'web') {
          setSideDrawerOpen(false);
          setRateDialogOpen(true);
        } else {
          Linking.openURL(Platform.OS === 'ios' ? globals.appStoreUrl : globals.playStoreUrl);
        }
      },
    },
    {
      key: 'about',
      title: i18n('about'),
      iconName: 'information',
      onPress: () => navigation.navigate(ABOUT_ROUTE),
    },
  ], [user.auth_provider_info, unreadChatMessages.length, isWhatsNewBadgeVisible, hasNewFollowers, i18n, styles, _completedExpanded, activeMemoryGoals, activeReadingGoals, activeGroupGoals, completedGoals, navigation]);

  const menu = useMemo(() => {
    return (
      <SideDrawer
        displayName={user.display_name || ''}
        username={user.username || ''}
        options={sideDrawerOptions}
      />
    );
  }, [user.display_name, sideDrawerOptions, user.username]);

  const [_foo, setFoo] = useState(false);

  useEffect(() => { // @TODO: this is a hack while react-native-paper is unsupported i think
    setTimeout(() => {
      setFoo(true);
    }, 100);
  }, []);

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // @NOTE: this is zero-based
  let yearInReviewYear = null;
  let yearForBibleInAYear = currentDate.getFullYear();
  if (currentMonth === 1 && currentDate.getDate() <= 7) {
    yearInReviewYear = currentDate.getFullYear() - 1;
  } else if (currentMonth === 12) {
    yearInReviewYear = currentDate.getFullYear();
    yearForBibleInAYear = currentDate.getFullYear() - 1;
  }

  let hideYearInReview = false;
  if (new Date() <= dateFnsAdd(new Date(user.created_at), {days: 14})) {
    // hide year in review if user was created in the last 14 days
    hideYearInReview = true;
  } else if (lifetimePeanuts < 100) {
    // hide year in review if user has fewer than 100 lifetime peanuts
    hideYearInReview = true;
  }

  const showBibleInAYearFab = (!isYearlyGoalAlreadyAdded && ((currentMonth === 1) || (currentMonth === 12 && currentDate.getDate() >= 14)));

  const stackedFabs = [];
  if (showBibleInAYearFab) {
    stackedFabs.unshift(
      <TouchableOpacity
        onPress={() => setIsBibleInAYearDialogOpen(true)}
      >
        <Image
          style={styles.fabImage}
          source={ELEPHANT_BIBLE_IN_A_YEAR}
        />
        <Text style={styles.fabText}>{yearForBibleInAYear}</Text>
      </TouchableOpacity>,
    );
  }
  if (!!yearInReviewYear && !hideYearInReview) {
    stackedFabs.unshift(
      <TouchableOpacity
        onPress={() => navigation.navigate(YEAR_IN_REVIEW_ROUTE, {
          year: yearInReviewYear,
        })}
      >
        <Image
          style={styles.fabImage}
          source={BRAIN_YEAR_IN_REVIEW}
        />
        <Text style={styles.fabText}>{yearInReviewYear}</Text>
      </TouchableOpacity>,
    );
  }

  return (
    <React.Fragment>
      <SideDrawerWrapper
        width={width}// when ipads change orientation, we need to re-render the side drawer
        open={_sideDrawerOpen}
        setOpen={setSideDrawerOpen}
        header={
          <Header
            centerComponent={
              <View style={styles.headerComponentWrapper}>
                <Text style={styles.headerText} adjustsFontSizeToFit={true}>Wrinkly</Text>
                <Image
                  style={[styles.graphic, styles.elephantGraphic]}
                  source={ELEPHANT_STANDARD}
                />
                <Image
                  style={[styles.graphic, styles.brainGraphic]}
                  source={BRAIN_STANDARD}// @TODO: this hangs down too far on web
                />
              </View>
            }
            alwaysCenterTitle={true}
            leftItems={[sideDrawerItem]}
            rightItems={[searchItem]}
          />
        }
        sideDrawerContent={menu}
        homeContent={
          <React.Fragment>
            {!!(betaOn && numRetryLater) && (
              <View style={styles.betaBanner}>
                <Text style={styles.betaBannerText}>{numRetryLater} offline lessons ready to sync.</Text>
              </View>
            )}
            <FullScreenScrollView contentContainerStyle={styles.innerContainer(stackedFabs.length)}>
              {_searchOpen && <SuperSearch />}{/* @TODO: this should maybe be outside of the scrollview */}
              {/* @TODO:
              <Text>{JSON.stringify(_allVerseTexts)}</Text>
              */}
              <MainDashboard
                visible={!_searchOpen}
                recentGoals={[...activeMemoryGoals, ...activeReadingGoals, ...activeGroupGoals].sort((a, b) => new Date(b.mostRecentActivity).getTime() - new Date(a.mostRecentActivity).getTime())}// @TODO: make sure this shows wrinkly101 on open (and at least one goal even if they're all completed? or just a button for "new goal"?)
              />
            </FullScreenScrollView>
            {stackedFabs.map((fab, index) => {
              return React.cloneElement(fab, {
                key: index,
                style: {
                  ...styles.fab(index),
                  ...(fab.props.style ?? {}),
                },
              });
            })}
          </React.Fragment>
        }
        translationSelectionDialog={
          <TranslationSelectionDialog
            // @TODO: isOpen={fetchGoalsCompleted && !Object.keys(goals).length}
            isOpen={_foo && fetchGoalsCompleted && !Object.keys(goals).length}
            autoClose={false}
            closeButtonText={i18n('continue')}
            title={i18n('initialSetup')}
            description={<Text style={styles.sectionTitle}>{i18n('selectPreferredTranslation')}</Text>}
            continueButtonDisabledWithActivityIndicator={addWrinkly101InFlight}
            onClose={(translationId) => {
              dispatch(addWrinkly101(translationId));
              // @TODO: show loader indicator
              /* @TODO: okay to fetch whole translation? is it small enough that people won't be upset? // @TODO: first make sure that the flow of refreshing after updates to verses is back end is performant
              if (t.downloadable) {
                dispatch(fetchVerses(newPreferredTranslationId));
              }
              */
            }}
            hideSettingsToggle={true}
          />
        }
      />
      {Platform.OS === 'web' && _rateDialogOpen &&
        <RateDialog onClose={() => setRateDialogOpen(false)} />
      }
      {_isBibleInAYearDialogOpen && <BibleInAYearDialog onClose={() => setIsBibleInAYearDialogOpen(false)} />}
    </React.Fragment>
  );
};

export default Home;
